/* Product selection handoff only. This module never writes to the cart. */
(() => {
  function selection(products,productId,variantId,quantity){
    const product=products.findIndex(p=>String(p.id).split('/').pop()===String(productId));
    const variant=product<0?-1:products[product].variants.findIndex(v=>String(v.id).split('/').pop()===String(variantId));
    if(variant<0||!Number.isSafeInteger(quantity)||quantity<1||quantity>1000)return null;
    return {product,groups:[{variant,qty:quantity,design:''}],mode:'shared',text:'',names:'',notes:''};
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={selection};return;}
  window.StcProductEntry={selection};
  if(customElements.get('stc-product-entry'))return;

  customElements.define('stc-product-entry',class extends HTMLElement{
    connectedCallback(){
      this.button=this.querySelector('button');this.message=this.querySelector('[role="status"]');
      this.refresh=this.refresh.bind(this);this.onChange=()=>queueMicrotask(this.refresh);
      this.onClick=()=>this.launch();this.button.addEventListener('click',this.onClick);
      this.onSubmit=event=>{const current=this.current();if(event.target===current?.form&&current.supported){event.preventDefault();event.stopImmediatePropagation();this.launch();}};
      document.addEventListener('submit',this.onSubmit,true);
      document.addEventListener('change',this.onChange);
      this.scope=this.closest('product-info')||this.parentElement;
      this.observer=new MutationObserver(this.refresh);
      this.observer.observe(this.scope,{childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','aria-disabled']});
      this.products=this.dataset.enabled==='true'?[{id:this.dataset.product,catalogSource:'native'}]:[];this.refresh();
    }
    disconnectedCallback(){document.removeEventListener('change',this.onChange);document.removeEventListener('submit',this.onSubmit,true);this.button?.removeEventListener('click',this.onClick);this.observer?.disconnect();}
    current(){
      const form=document.getElementById(this.dataset.form);if(!form)return null;
      const id=form.elements.namedItem('id'),qty=form.elements.namedItem('quantity');
      const product=(this.products||[]).find(p=>String(p.id).split('/').pop()===this.dataset.product);
      if(product?.catalogSource==='native'){
        const quantity=Number(qty?.value||1),supported=/^\d+$/.test(id?.value||'');
        return {form,id,qty,supported,plan:supported&&Number.isSafeInteger(quantity)&&quantity>=1&&quantity<=1000?{groups:[{qty:quantity}]}:null};
      }
      return {form,id,qty,supported:!!selection(this.products||[],this.dataset.product,id?.value,1),plan:selection(this.products||[],this.dataset.product,id?.value,Number(qty?.value||1))};
    }
    refresh(){
      const current=this.current(),submit=current?.form.querySelector('[name="add"]');if(!submit)return;
      const supported=current.supported;
      if(this.button.hidden===supported)this.button.hidden=!supported;
      if(submit.hidden!==supported)submit.hidden=supported;
      this.button.classList.toggle('hidden',!supported);submit.classList.toggle('hidden',supported);
      const disabled=submit.disabled||submit.getAttribute('aria-disabled')==='true'||current.id?.disabled;
      if(this.button.disabled!==!!disabled)this.button.disabled=!!disabled;
      this.querySelector('[data-entry-help]').hidden=!supported;
    }
    launch(){
      const current=this.current();if(!current?.supported||this.button.disabled)return;
      if(current.qty&&!current.qty.reportValidity())return;
      if(!current.plan){this.message.textContent='Choose a whole-number quantity from 1 to 1,000.';return;}
      const url=new URL(this.dataset.studio,location.origin);
      url.searchParams.set('ob_product',this.dataset.product);url.searchParams.set('ob_variant',current.id.value);
      url.searchParams.set('ob_qty',String(current.plan.groups[0].qty));url.searchParams.set('ob_entry',crypto.randomUUID());
      location.assign(url.href);
    }
  });
})();


